import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-player-card',
  templateUrl: './player-card.component.html',
  styleUrls: ['./player-card.component.scss']
})
export class TecnoPlayerCardComponent implements OnInit {
  loadIndicator = false
  participants;

  constructor(private eventService: EventsService, public globalService: GlobalService) {
  }

  ngOnInit() {
    this.loadIndicator = true

    this.loadIndicator = true
    this.eventService.getWinnerTournament('tecno-pubg-mobile-cup','singles').subscribe(res=>{
      this.participants = res.data;
      this.loadIndicator = false
    })
  }

}
